export const SET_TOKEN_DATA = 'SET_TOKEN_DATA';
